import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useBatches } from "./PoRows";
import { apiError, btnPrimary, countryLabel, fmtDateTimeWIB, inp } from "./util";

export default function PoBatches() {
    const { user } = useAuth();
    const [archived, setArchived] = useState(false);
    const [q, setQ] = useState("");
    const [{ countries, items }, reload] = useBatches(archived, q);
    const [country, setCountry] = useState("Japan");
    const [name, setName] = useState("");
    const canCreate = ["owner", "admin_sales"].includes(user?.role);
    const create = async () => {
        try {
            await api.post("/reporting/po-batches", { country, name });
            toast.success("Batch PO dibuat");
            setName("");
            reload();
        } catch (e) {
            toast.error(await apiError(e));
        }
    };
    return (
        <div className="space-y-5" data-testid="po-batches">
            {canCreate && (
                <div className="grid sm:grid-cols-[180px_1fr_auto] gap-3 items-end bg-white/70 border border-mist rounded-sm p-4">
                    <label className="text-xs text-neutral-500">Negara
                        <select value={country} onChange={(e) => setCountry(e.target.value)} className={`${inp} mt-1`} data-testid="batch-country-select">
                            {countries.map((c) => <option key={c} value={c}>{countryLabel(c)}</option>)}
                        </select>
                    </label>
                    <label className="text-xs text-neutral-500">Nama batch
                        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Japan October 2026" className={`${inp} mt-1`} data-testid="batch-name-input" />
                    </label>
                    <button type="button" onClick={create} disabled={name.trim().length < 2} className={btnPrimary} data-testid="batch-create-btn"><Plus size={14} /> Buat</button>
                </div>
            )}
            <div className="flex flex-wrap gap-3 items-center">
                <label className="text-xs text-neutral-500 inline-flex items-center gap-1.5">
                    <input type="checkbox" checked={archived} onChange={(e) => setArchived(e.target.checked)} data-testid="batches-archived-toggle" /> Tampilkan arsip (lebih dari 6 bulan)
                </label>
                <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari batch" className={`${inp} w-60`} data-testid="batches-search" />
            </div>
            <div className="overflow-x-auto border border-mist rounded-sm bg-white">
                <table className="w-full text-sm" data-testid="batches-table">
                    <thead className="bg-neutral-50 text-neutral-500 text-xs">
                        <tr>{["Batch", "Negara", "Dibuat", "Disembunyikan otomatis", "Status"].map((h) => <th key={h} className="text-left font-normal px-3 py-2">{h}</th>)}</tr>
                    </thead>
                    <tbody>
                        {items.map((b) => (
                            <tr key={b.id} className="border-t border-mist" data-testid={`batch-row-${b.id}`}>
                                <td className="px-3 py-2.5">{b.name}</td>
                                <td className="px-3 py-2.5">{countryLabel(b.country)}</td>
                                <td className="px-3 py-2.5 text-xs">{fmtDateTimeWIB(b.created_at)}</td>
                                <td className="px-3 py-2.5 text-xs">{fmtDateTimeWIB(b.hide_after)}</td>
                                <td className="px-3 py-2.5 text-xs">{b.archived ? "Diarsipkan" : "Ditampilkan"}</td>
                            </tr>
                        ))}
                        {!items.length && <tr><td colSpan={5} className="px-3 py-4 text-xs text-neutral-400">Belum ada batch.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
